<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk"><span aria-label="ii" class="page" id="pii" role="doc-pagebreak"></span><span aria-label="iii" class="page" id="piii" role="doc-pagebreak"></span>Civil Religion Today</h1>
<h1 class="bk1">Religion and the American Nation in the Twenty-First Century</h1>
<p class="bkau">Edited by Rhys H. Williams, Raymond Haberski Jr., and Philip Goff</p>
<p class="bkpub"><img alt="" height="44" src="images/NYU_TitlePage_Logo.jpg" width="35"/></p>
<p class="bkpub">NEW YORK UNIVERSITY Press</p>
<p class="bkpub1">New York</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// williamsCivilReligion-0003.vue?c5379d1c